export const ALL_NEWS = [
  {
    "title": "VEQ invests in proptech company Nrlyze",
    "date": "Oct 12, 2023",
    "category": "Investment",
    "link": "https://veq.vc/news/veq-invests-in-proptech-company-nrlyze",
    "slug": "veq-invests-in-proptech-company-nrlyze",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
    "description": "Today we're announcing our investment in property energy optimization company Nrlyze! We're excited to team up with Stockholm-based proptech company Nrlyze.",
    "excerpt": "Today we're announcing our investment in property energy optimization company Nrlyze! We're excited to team up with Stockholm-based proptech company Nrlyze.",
    "content": [
      {
        "children": [
          {
            "key": "c1",
            "marks": [],
            "text": "Today we're announcing our investment in property energy optimization company Nrlyze!",
            "type": "span"
          }
        ],
        "key": "b1",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c2",
            "marks": [],
            "text": "We're excited to team up with Stockholm-based proptech company Nrlyze. The company increases energy efficiency in buildings using proprietary hardware sensors and a software platform deploying algorithms to optimize energy usage.",
            "type": "span"
          }
        ],
        "key": "b2",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c3",
            "marks": [],
            "text": "Nrlyze was founded by Lars Hansson and Christian Engstrand, two outstanding engineers with background from companies like Scania, Regin, Northvolt and Exeger. They have have built a proprietary hardware and software solution that beats most of the competition when it comes to achieved energy savings, functionality and ease of use. They have done this with a very limited budget and team and we're really excited to see what they can achieve with this additional funding.",
            "type": "span"
          }
        ],
        "key": "b3",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c4",
            "marks": [],
            "text": "VEQ is leading the round of 10 mSEK and we’re happy to co-invest with most existing investors including the Northvolt founding team as well as new investor AIpa Invesco bringing real industry expertise through their previous journey with company Termotech.",
            "type": "span"
          }
        ],
        "key": "b4",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c5",
            "marks": [],
            "text": "For more information about the company, contact Cofounder and CEO Lars Hansson at lars@nrlyze.se or +46760223079",
            "type": "span"
          }
        ],
        "key": "b5",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "Launching VEQ Fund 2 and announcing our first investment: Mai",
    "date": "Jun 18, 2025",
    "category": "News",
    "link": "https://veq.vc/news/launching-veq-fund-2-and-announcing-our-first-investment-mai",
    "slug": "launching-veq-fund-2-and-announcing-our-first-investment-mai",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/257671033bd165703df8a01be37eb8bfdde5abc8-1398x472.png",
    "description": "We’re proud to launch VEQ Fund 2 - a 200 mSEK fund to support the next wave of early stage Swedish software enabled businesses – and we are kicking it off with our investment in Mai ",
    "content": [
      {
        "children": [
          {
            "key": "2c0b5c6d3324",
            "marks": [],
            "text": "Today, we’re proud to announce the launch of VEQ Fund 2 – and to share that our first investment from the new fund is in ",
            "type": "span"
          },
          {
            "key": "f48eaa94b4bb",
            "marks": [
              "be7aef4ee838"
            ],
            "text": "Mai",
            "type": "span"
          },
          {
            "key": "ae29d8032fa1",
            "marks": [],
            "text": ", a Stockholm-based company leveraging technology to radically improve the second-hand fashion selling experience.",
            "type": "span"
          }
        ],
        "key": "e660558a025a",
        "markDefs": [
          {
            "href": "https://www.maiapp.se/",
            "key": "be7aef4ee838",
            "type": "link"
          }
        ],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "b165cdd15114",
            "marks": [],
            "text": "This marks an important milestone for VEQ. Since launching in 2021, we’ve partnered with 9 Swedish startups – all led by ambitious teams building for the long term. Across the portfolio, we’ve seen solid business fundamentals, thoughtful growth and strong resilience from the founders we’ve backed.",
            "type": "span"
          }
        ],
        "key": "761514999d4f",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "2145b598bbcb",
            "marks": [],
            "text": "With our second fund, we’re doubling down on our hands-on approach and will be investing 200 mSEK in software enabled companies from Sweden in the early commercial phase. The strategy is sector- and business model agnostic and more concentrated compared to most other VC-funds. We’re also proud to continue our close partnership with Alfvén & Didrikson, who are returning as our lead investor, alongside existing and new Swedish family offices and high net worth individuals.",
            "type": "span"
          }
        ],
        "key": "056614f92dae",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c8d7f6427283",
            "marks": [],
            "text": "Why we’re investing in Mai",
            "type": "span"
          }
        ],
        "key": "f83b1c54bd76",
        "markDefs": [],
        "style": "h3",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "6426f427ea5b",
            "marks": [],
            "text": "Founded by Emma Rosman, Tobias Rosman, and Daniel Sundman, ",
            "type": "span"
          },
          {
            "key": "5eedd5259b65",
            "marks": [],
            "text": "Mai",
            "type": "span"
          },
          {
            "key": "76b2f97bc8f7",
            "marks": [],
            "text": " is building the tech platform that powers second-hand fashion. Rather than launching yet another marketplace, Mai integrates with existing ones – helping users price, publish and manage their listings through one simple interface.",
            "type": "span"
          }
        ],
        "key": "baeac871588c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "1679f16ac708",
            "marks": [],
            "text": "The platform uses AI to recommend optimal pricing, automate listing creation, and improve sell-through rates. Users simply photograph an item – Mai handles the rest, distributing the listing across multiple marketplaces and tracking its performance.",
            "type": "span"
          }
        ],
        "key": "e7289ff3a9df",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "70fe084d68c3",
            "marks": [],
            "text": "The result?",
            "type": "span"
          }
        ],
        "key": "f4b774b16fb6",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "272d4a5ff9f3",
            "marks": [],
            "text": "- A superior user experience for second hand sellers",
            "type": "span"
          }
        ],
        "key": "2b72a952d449",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "50d4e7280355",
            "marks": [],
            "text": "- Higher sell-through rates and more profitable sales",
            "type": "span"
          }
        ],
        "key": "5f8c56989781",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "e1c6ea405582",
            "marks": [],
            "text": "- A model built to scale with both users and marketplaces",
            "type": "span"
          }
        ],
        "key": "180dbbb3cacc",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "6cb3d4aefd6f",
            "marks": [],
            "text": "The founding team brings deep experience from marketplaces and fast-scaling tech companies like Uber, Epidemic Sound, and Kry, giving them a unique perspective on product, operations and growth. They’ve impressed us with their speed, clarity and customer-first mindset from day one. VEQ is leading the round of 7 mSEK and we’re happy to co-invest with Icebreaker, SSE Ventures and reputable business angels.",
            "type": "span"
          }
        ],
        "key": "ed7e2e9819fa",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "65b5ba26f1e2",
            "marks": [],
            "text": "“Sustainable consumption shouldn’t require extra effort – and with Mai, it doesn’t. We’re excited to support a team that’s making circular fashion the default.” - Maria Bergsten, Partner at VEQ",
            "type": "span"
          }
        ],
        "key": "0c673b702314",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "29cdfa5ea69e",
            "marks": [],
            "text": "We’re thrilled to welcome ",
            "type": "span"
          },
          {
            "key": "d40fccc43492",
            "marks": [],
            "text": "Mai",
            "type": "span"
          },
          {
            "key": "2d11b735b48f",
            "marks": [],
            "text": " to the VEQ family – and excited for all new possibilities ahead with Fund 2. A big thank you to our founders, partners, and both new and old investors for continuing the journey with us.",
            "type": "span"
          }
        ],
        "key": "47526d006a11",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "Welcoming Virtual Days to the VEQ family",
    "date": "Aug 20, 2024",
    "category": "News",
    "link": "https://veq.vc/news/welcoming-virtual-days-to-the-veq-family",
    "slug": "welcoming-virtual-days-to-the-veq-family",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/ef869ba87050e6af5240ce6cc649dd985f83c5f1-3130x2087.jpg",
    "description": "We are excited to announce our investment in virtual event company Virtual Days!",
    "content": [
      {
        "children": [
          {
            "key": "cc5b70ecb93f",
            "marks": [],
            "text": "We have invested in Virtual Days, a company leveraging data and AI to create virtual experiences with focus on the HR and recruitment industry.",
            "type": "span"
          }
        ],
        "key": "c1cf5c152385",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "4ade1348a78a",
            "marks": [],
            "text": "VEQ is proud to have co-led this investment round of 10 mSEK together with Quinary Investment and the founders Mattias and Lina who also are participating in the financing round.",
            "type": "span"
          }
        ],
        "key": "14c839e31f24",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c31249cc610f",
            "marks": [],
            "text": "\"We were very impressed by the team and their deep expertise both within the HR and recruitment industry but also their capabilities within data and AI. It always feels extra good to support highly skilled founding teams that also are diverse.\" says Viktor Gällström, Partner at VEQ",
            "type": "span"
          }
        ],
        "key": "d159c8846639",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "db4ed47af7b4",
            "marks": [],
            "text": "The capital will be used for international expansion and the focus for now will be on the HR and recruitment industry. In the future, additional verticals may be added as the use cases for the technology owned by the company are many.",
            "type": "span"
          }
        ],
        "key": "acb0aaff5180",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "889d8200071d0",
            "marks": [],
            "text": "\"We have a unique platform that blurs the lines between physical and digital meetings. The versatility of the platform makes it useful in multiple areas, but right now our focus is on recruitment and onboarding. Companies can position themselves as attractive employers by participating in our recruitment events or using a digital copy of their headquarters for everything from recruitment to internal events and onboarding,\" says Mattias Säker, CEO of Virtual Days.",
            "type": "span"
          }
        ],
        "key": "63503e499fe5",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "033604c9e6b5",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "61071ab82314",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "3fd715cb4ae1",
            "marks": [],
            "text": "For more information, contact CEO Mattias Säker at mattias@virtualdays.com or +46 707 5374 59",
            "type": "span"
          }
        ],
        "key": "28201ee8c0e9",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "VEQ increases ownership in forestry software company Ecotype",
    "date": "Jun 27, 2024",
    "category": "News",
    "link": "https://veq.vc/news/veq-increases-ownership-in-forestry-software-company-ecotype",
    "slug": "veq-increases-ownership-in-forestry-software-company-ecotype",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/13933feec7fe95db08abb0852213299e02748fe8-640x427.jpg",
    "description": "Today we're extremely glad to announce that VEQ has increased ownership stake in forestry software company Ecotype in an internal financing together with other existing co-investors.",
    "content": [
      {
        "children": [
          {
            "key": "4862f360aaca0",
            "marks": [],
            "text": "The funding will be used to support roll-out together with large industrial customers on the Swedish market, as well as for international expansion.",
            "type": "span"
          }
        ],
        "key": "14ef716648f1",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "fc0612cf2e98",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "4e0a13a05422",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "0022bc6d941b0",
            "marks": [],
            "text": "We have increased our ownership stake to close to 15% in the company and increased our engagement even further. All existing investors participated in the financing which speaks to the strength and promise of this young company.",
            "type": "span"
          }
        ],
        "key": "17ddcf221f77",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "37bd083b980d",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "ae6c0d336816",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "6c37ec33c38d",
            "marks": [],
            "text": "“After having worked closely to Axel and Albin with team for 1,5 years and having seen the tremendous achievements they've accomplished in disrupting the forestry industry with new innovative digital solutions, all in this short time span, I am very happy that we got the chance to increase our ownership in this impressive company”, says Viktor Gällström, Partner at VEQ.",
            "type": "span"
          }
        ],
        "key": "5c41eaf032aa",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "919c5abd51f5",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "86918a5d9935",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "a7acd31231800",
            "marks": [],
            "text": "Founded in 2020, Ecotype specializes in digital solutions for the forestry industry. The core of the company's offering goes by the name \"Skogshubben\" in Sweden. Skogshubben is a software platform that instantly let's forestry companies, private forest owners, or other stakeholders see all data on their forest property including a real time digital forestry plan with cash flow forecasts, financial value of the forest, CO2 impact and much much more.",
            "type": "span"
          }
        ],
        "key": "abaab2e14e14",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "0293f677d2aa",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "2f5de4ab8948",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "6fbf77d7a46d0",
            "marks": [],
            "text": "For more information, contact:\nAxel Ljudén, CEO\naxel.ljuden@ecotype.com",
            "type": "span"
          }
        ],
        "key": "cd9e9bf0b4fe",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "Norban becomes part of the VEQ family",
    "date": "Sep 11, 2023",
    "category": "News",
    "link": "https://veq.vc/news/norban-becomes-part-of-the-veq-family",
    "slug": "norban-becomes-part-of-the-veq-family",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/da22754e8076451eaf46ec93d386601bf2d90bc0-7789x5195.jpg",
    "description": "VEQ Invests in Norban, the leading digital real estate broker and marketplace in Sweden",
    "content": [
      {
        "children": [
          {
            "key": "73b25373e1ab",
            "marks": [],
            "text": "We are very excited to announce our participation as the lead investor in the recent 25 mSEK capital raise by digital real estate broker and marketplace Norban.",
            "type": "span"
          }
        ],
        "key": "bbdd99c8de76",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "8afca4276e35",
            "marks": [],
            "text": "Norban has in recent years established itself as the leading digital broker and created a Pre-Market for housing transactions in Sweden with over 50 000 users and transactions worth over 4 billion sek.",
            "type": "span"
          }
        ],
        "key": "e4e900b68df6",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "3a5f4f8a13b2",
            "marks": [],
            "text": "The company is disrupting this industry that has not yet seen much of digitalisation and offers sellers and buyers of homes a smooth and frictionless journey towards selling/buying a new home.",
            "type": "span"
          }
        ],
        "key": "f077eb82c24d",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "e0290e45b4d9",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "72d04f660888",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "cd788a8e5d3a",
            "marks": [],
            "text": "Viktor Gällström, Partner at VEQ comments:",
            "type": "span"
          }
        ],
        "key": "6639140d2cce",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "20c4c974e6e2",
            "marks": [],
            "text": "When we met the team behind Norban we were very impressed with what they had accomplished in just a few years. They are changing a whole market which feels very exciting and we are sure that they are on to something big. We are looking forward to work with the company and help them change the way we buy and sell or homes today.",
            "type": "span"
          }
        ],
        "key": "038d53160658",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "0eef76f95e27",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "82cadb5bf5c1",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "e5b959ce4819",
            "marks": [],
            "text": "To learn more, visit www.norban.se",
            "type": "span"
          }
        ],
        "key": "f43314f68c5c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "VEQ invests in Fundrella - an ESG analytics and matchmaking platform for asset managers and investors",
    "date": "Aug 28, 2023",
    "category": "News",
    "link": "https://veq.vc/news/veq-invests-in-fundrella-an-esg-analytics-and-matchmaking-platform-for-asset-managers-and-investors",
    "slug": "veq-invests-in-fundrella-an-esg-analytics-and-matchmaking-platform-for-asset-managers-and-investors",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/f7e9b19848ff579bd5ff12546877475452a76977-4389x2500.jpg",
    "description": "Today we’re happy to announce our investment in ESG analytics platform Fundrella! We’re excited to join forces with founder and CEO Wava Bodin and together contribute to more transparency and sustainability in the financial sector.",
    "content": [
      {
        "children": [
          {
            "key": "986d2fc395940",
            "marks": [],
            "text": "Today we’re happy to announce our investment in ESG analytics platform Fundrella! We’re excited to join forces with Founder and CEO Wava Bodin and together contribute to more transparency and sustainability in the financial sector. VEQ led the round of c. 7 million SEK, alongside current investors and business angels.",
            "type": "span"
          }
        ],
        "key": "a6ff4636975e",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "61851ab5731b",
            "marks": [],
            "text": "Fundrella empowers asset managers and institutional investors with their ESG focused SaaS platform. The company provides their customers with unique ESG market insights and the possibility for investors and asset managers to match, based on their preferences.",
            "type": "span"
          }
        ],
        "key": "48a7027b2c06",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "b32894129d08",
            "marks": [],
            "text": "The platform's user-friendly interface offers a comprehensive database of funds, allowing investors to fine-tune their preferences and effortlessly discover opportunities that reflect their requirements. This also gives investors a chance to play a more active role in communicating their ESG preferences and shaping their investment strategies.",
            "type": "span"
          }
        ],
        "key": "9255670b5672",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "d65da5770b7a",
            "marks": [],
            "text": "\"Our platform's ability to match investors with ESG-aligned funds not only accelerates sustainable investment decisions and makes the market more efficient, but also addresses the growing need for more transparency and helping asset managers understand what the ESG requirements amongst professional investors ",
            "type": "span"
          },
          {
            "key": "986d2fc395941",
            "marks": [
              "em"
            ],
            "text": "actually",
            "type": "span"
          },
          {
            "key": "986d2fc395942",
            "marks": [],
            "text": " are and what they can do to better adhere to them.” - explains founder Wava Bodin.",
            "type": "span"
          }
        ],
        "key": "8a9fc5706b6b",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "cf04e9e27eb4",
            "marks": [],
            "text": "The Fundrella platform is already used by professional investors representing EUR 580 billion in investable assets and leading asset managers, including ten of the top twenty asset managers globally.",
            "type": "span"
          }
        ],
        "key": "033371d2ac40",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "58bcdc29ed53",
            "marks": [],
            "text": "We're excited about supporting the ambitious Fundrella team and we look forward to seeing them expand into more markets in Europe during the fall. ",
            "type": "span"
          }
        ],
        "key": "81f741a15dc2",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "e1ae99f2b9c6",
            "marks": [],
            "text": "Let’s go!",
            "type": "span"
          }
        ],
        "key": "f82b59dec36e",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "VEQ increases ownership in drone software company Airpelago",
    "date": "Dec 12, 2022",
    "category": "News",
    "link": "https://veq.vc/news/veq-increases-ownership-in-drone-software-company-airpelago",
    "slug": "veq-increases-ownership-in-drone-software-company-airpelago",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/8c626c04938b14f9148d3eb079f662003064a371-617x465.png",
    "description": "We are happy to announce that we’ve increased our ownership in drone software company Airpelago by leading their 8,5 mSEK seed round.",
    "content": [
      {
        "children": [
          {
            "key": "4862f360aaca0",
            "marks": [],
            "text": "The funding will be used to support roll-out of large upcoming projects on the Swedish market, as well as for international expansion.",
            "type": "span"
          }
        ],
        "key": "14ef716648f1",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "fc0612cf2e98",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "4e0a13a05422",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "0022bc6d941b0",
            "marks": [],
            "text": "We have doubled our ownership stake to close to 20% in the company and increased our engagement significantly. Other co-investors in the round include Sustainable Energy Angels, We Are Angels and most significantly several of Airpelago’s employees.",
            "type": "span"
          }
        ],
        "key": "17ddcf221f77",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "1fcea19b1b43",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "efd970a63f35",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "57574a3efd7e0",
            "marks": [],
            "text": "“We are very proud that both existing and new investors, as well as our own employees, believe in our vision of better, greener and more efficient inspections of linear infrastructure” says Max Hjalmarsson, Co-founder and CEO of Airpelago.",
            "type": "span"
          }
        ],
        "key": "9858a4dd317b",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "37bd083b980d",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "ae6c0d336816",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "581b3ef2d8130",
            "marks": [],
            "text": "“I’ve had the privilege to work with the team behind Airpelago for about a year now and I’m very impressed with what they have accomplished in such a short time. When we got the opportunity to increase our ownership in the company it was a no-brainer”, says Viktor Gällström, Partner at VEQ.",
            "type": "span"
          }
        ],
        "key": "76416e1b1578",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "919c5abd51f5",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "86918a5d9935",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "a7acd31231800",
            "marks": [],
            "text": "Founded in 2018, Airpelago specializes in developing automation software which streamlines large-scale inspections of linear infrastructure with drones. In 2022 the company secured a strong position on the Swedish market for power line inspections, with successful projects for Sweden’s largest electrical utility companies: EOn, Ellevio, Vattenfall and Svenska Kraftnät. Airpelago now turns its focus towards international expansion and has ongoing leads with customers in Norway, Finland, Germany, France and Poland. The company has also proven to be a front-runner in drone regulations, acquiring the first permit in Sweden which allows flying drones beyond line of sight without the need for restricted airspace.",
            "type": "span"
          }
        ],
        "key": "abaab2e14e14",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "061252d502db",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "4585645495f6",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "3911b563c7fe0",
            "marks": [],
            "text": "“The key to our success is our world-class automation software. Thanks to the new funding we will reach more customers both in Sweden and around the world, helping them get a better picture of the status of their critical infrastructure while heavily reducing their carbon footprint” says Tobias Fridén, Co-founder and CTO of Airpelago.",
            "type": "span"
          }
        ],
        "key": "238e33e5b0fa",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "0293f677d2aa",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "2f5de4ab8948",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "6fbf77d7a46d0",
            "marks": [],
            "text": "For more information, contact:\nMax Hjalmarsson, CEO\nmax@airpelago.com",
            "type": "span"
          }
        ],
        "key": "cd9e9bf0b4fe",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "GLOBHE closes seed round of 20 MSEK to accelerate access to climate data from drones globally",
    "date": "Sep 5, 2022",
    "category": "News",
    "link": "https://veq.vc/news/globhe-closes-seed-round-of-20-msek-to-accelerate-access-to-climate-data-from-drones-globally",
    "slug": "globhe-closes-seed-round-of-20-msek-to-accelerate-access-to-climate-data-from-drones-globally",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/4ae3d9fecbae406517aca01d8775f04b1c2e7620-2048x1536.jpg",
    "description": "VEQ investee company GLOBHE just closed their seed round, and we’re happy to welcome new investors such as Course Corrected and MIT onboard. We invested in GLOBHE in August 2021 and we’re happy to participate in the seed round as well.",
    "content": [
      {
        "children": [
          {
            "key": "d7e6faa126730",
            "marks": [],
            "text": "”The time for planet action is yesterday. But action requires data. We have seen an increased interest this year from actors worldwide, which means sales and impact numbers are taking off. We are going from a startup to a scaleup, and on that journey, you need increased capital, cutting-edge knowledge, and investors who share your mission. I’m thrilled to have found that in our Nordic and American impact tech investors,” says Helena Samsioe, Founder and CEO of GLOBHE.",
            "type": "span"
          }
        ],
        "key": "0917523c905c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "879547e6cfa40",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "10a3fcef8273",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "b410af6bb255",
            "marks": [],
            "text": "GLOBHE’s innovative product, the SaaS platform Crowddroning by GLOBHE, connects its global crowd of local drone operators with businesses, organizations, and researchers in need of high-resolution earth observation data. The data is vital to understand the world and take action towards a more sustainable future.",
            "type": "span"
          }
        ],
        "key": "f56420c33c03",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "948e9bed38be0",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "c6d477c39242",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "b924a0b09848",
            "marks": [],
            "text": "Currently, Crowddroning connects to 6000+ local drone operators in 117 countries, and the numbers are increasing daily. Clients range from organizations such as the United Nations and the World Bank to clean energy and big data companies.\n\n",
            "type": "span"
          }
        ],
        "key": "4cbfe30ccc66",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "5ae92407f8e7",
            "marks": [],
            "text": "“The work that the GLOBHE team does is very important – they’re creating true positive impact for people all over the world and the whole planet. We’re proud to continue to support them on their growth journey.” – Our VEQ Partner Maria Bergsten.",
            "type": "span"
          }
        ],
        "key": "69fa58a093d5",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "7b5914b77de90",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "209d3c83241a",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "a02716bd4879",
            "marks": [],
            "text": "Go GLOBHE!",
            "type": "span"
          }
        ],
        "key": "dee0fd1e507e",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "We’re happy to announce VEQ’s investment in Vitala",
    "date": "May 6, 2022",
    "category": "News",
    "link": "https://veq.vc/news/we-re-happy-to-announce-veq-s-investment-in-vitala",
    "slug": "we-re-happy-to-announce-veq-s-investment-in-vitala",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/abd14f57e619c9a74636182b489b7ce7cefea723-1501x1000.jpg",
    "description": "Today we’re thrilled to announce that VEQ is backing the Vitala team!",
    "content": [
      {
        "children": [
          {
            "key": "b3d013ef32820",
            "marks": [],
            "text": "The digital health platform Vitala just raised capital to continue their growth journey and create increased physical activity among patients with chronic illnesses. Vitala combines evidence based knowledge and tech to customise medical exercise and rehabilitation to patients in an automated, efficient and secure way. VEQ led the investment round of more than 9 million SEK and invested alongside current investors such as Curus (previous Add Health Media), Partnerinvest Norr and several reputable health tech investors.",
            "type": "span"
          }
        ],
        "key": "91a5a2613c04",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "3046499780060",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "60b892523bdc",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "be2761ae32ef",
            "marks": [],
            "text": "“Medical exercise will be as natural to prescribe as pain killers” says Jesper Aasa, co-founder and Chief Medical Officer at Vitala.",
            "type": "span"
          }
        ],
        "key": "a7034d0b6a98",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "de52984667a60",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "9846b3225c84",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "cb16e84f4b8f",
            "marks": [],
            "text": "The company was founded in December 2020 and has since then launched its medical exercise app that has already helped over 5000 patients to a better health.The founding team (consisting of the three siblings Lisa, Jesper and Petter Aasa) is now in the midst of launching their unique caregiver dashboard that makes it possible for doctors to prescribe the Vitala app to their patients as a part of the treatment and also follow up on their health development.",
            "type": "span"
          }
        ],
        "key": "d24d53ec6822",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "5a0e5afa606a0",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "ea25724688dc",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "570b6ca633b7",
            "marks": [],
            "text": "“Vitala has built a unique and scalable product that truly helps patients to feel better and live a healthier life. We’re impressed by what the founders have achieved so far and incredibly proud to be a part of Vitalas exciting journey”, says VEQ Partner Maria Bergsten.",
            "type": "span"
          }
        ],
        "key": "908df31bddcb",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "570b08fca07a0",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "24ad1b956b24",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "bc536d108c6e",
            "marks": [],
            "text": "Let’s go, team Vitala!",
            "type": "span"
          }
        ],
        "key": "107f27bb5538",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "VEQ is now backing forest proptech company Ecotype",
    "date": "Mar 17, 2022",
    "category": "News",
    "link": "https://veq.vc/news/veq-is-now-backing-forest-proptech-company-ecotype",
    "slug": "veq-is-now-backing-forest-proptech-company-ecotype",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/9312444e37d755e461c1ca847fdfa2095561aa25-670x416.png",
    "description": "We are very proud to team up with Ecotype Founders and LRF Ventures in this investment in Ecotype, the holistic platform for the forestry industry.",
    "content": [
      {
        "children": [
          {
            "key": "a1c3ef804ab90",
            "marks": [],
            "text": "In the Ecotype platform, named Skogshubben in the Swedish market, anyone can see any data on forests across all of Sweden. Generally, the forest industry is lagging behind on digitalization even though it is one of the largest industries in Sweden, and we believe that Ecotype can fill that void.",
            "type": "span"
          }
        ],
        "key": "c050842f00f7",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "d4013f80a62c",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "878b34ac5206",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "ea468d9d92a70",
            "marks": [],
            "text": "The platform uses satellite data, LiDAR scans and open data sources to construct an interactive map of the forest, containing data on e.g. what kind of forest, how much timber one specific property holds, and the value of that timber. It also gives a heads up on risks to the forests, recommends when you should cut down the forest – or let you know how much carbon dioxide you can bind if you do not cut down the forest. Ultimately this kind of platform can replace the old fashion way of developing forestry plans across Europe.",
            "type": "span"
          }
        ],
        "key": "63de78dfbc56",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "ad570cea5023",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "ec36a39207fc",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "27812866e0bf0",
            "marks": [],
            "text": "Now we’re investing 8 mSEK together with LRF Ventures to boost product development and commercialization of the platform and we’re very excited to follow and support the team on their growth journey!",
            "type": "span"
          }
        ],
        "key": "ff3cd24e4c7f",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "Today we annouce our investment in furniture subscription company Beleco",
    "date": "Feb 10, 2022",
    "category": "News",
    "link": "https://veq.vc/news/today-we-annouce-our-investment-in-furniture-subscription-company-beleco",
    "slug": "today-we-annouce-our-investment-in-furniture-subscription-company-beleco",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/20dc4901ebf656dbfb8c444e00c5dc544b5ca85f-1536x1018.png",
    "description": "Beleco is the leading subscription service for flexible furniture subscriptions and we can now share that VEQ has joined Beleco as an investor. Together with Alfvén & Didrikson we led the investment round of c. 20 million SEK, alongside current investors such as, Almi Invest Green Tech. ",
    "content": [
      {
        "children": [
          {
            "key": "787ab098c57a0",
            "marks": [],
            "text": "Since 2020, Beleco has offered a long-term complete hybrid solution and today has 400+ B2B customers in Sweden such as Kry, Budbee and H&M. They provide complete and high qualitative furniture solutions for both offices and flexible and scalable home office solutions. Beleco also has their own proprietary software – Beleco Workspace – that gives their customers an overview of the rented furniture and allows their employees to order products themselves (from an assortment that the employer has selected for them).",
            "type": "span"
          }
        ],
        "key": "e70dbf84357a",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "690cc2247322",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "d8473bd77cb3",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "654c22d5da800",
            "marks": [],
            "text": "Maria Bergsten, our VEQ Partner comments:\n“For several years I have followed Beleco and their work on circular services for the furniture industry and been impressed by their way of constantly innovating, but also how they managed – almost behind the scenes – to build an entire digital infrastructure for handling products in a flexible rental model. It feels very exciting to now get to be a part of Beleco’s journey. ”",
            "type": "span"
          }
        ],
        "key": "46f4f3a49a45",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "aee27aea0c23",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "0fd4675002d4",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "56aa18395e550",
            "marks": [],
            "text": "Sebastian Rudenstam, co-founder of Beleco comments:\n“Now we enter the next age with hybrid work, that makes it possible to live and work anywhere. It also means that products and services need to adapt to this new world. I’m still just as full of energy and obsessed with creating the best solution for our users, partners and for the environment that I was a few years ago when we started.”",
            "type": "span"
          }
        ],
        "key": "d25b46e28983",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "3270baf07a4f",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "4b9b9c75da08",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "99cb8277645e0",
            "marks": [],
            "text": "The capital injection will be used for continued product development within Future of Work, as well as attracting more talent and increased marketing ahead of an international launch in Europe.",
            "type": "span"
          }
        ],
        "key": "acc821e56fd4",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "61a37588c3f2",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "7a7f8794da47",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "ed04bbc3be350",
            "marks": [],
            "text": "Let’s go, team Beleco!",
            "type": "span"
          }
        ],
        "key": "e23023c67ccc",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "VEQ invests in drone software company Airpelago",
    "date": "Oct 15, 2021",
    "category": "News",
    "link": "https://veq.vc/news/veq-invests-in-drone-software-company-airpelago",
    "slug": "veq-invests-in-drone-software-company-airpelago",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/9aee5ee1f2d0305d378ddbeb4da46e449a67317d-1536x863.jpg",
    "description": "Airpelago develops software that automates the inspection of power lines with drones. Drones are the future solution for efficient inspection of power lines and the transition to start using drones at scale has just begun. Airpelago’s software automates the inspection workflow and the solution is compatible with most professional off-the-shelf drones, which effectively facilitates the scaling of Airpelago’s software as a service. ",
    "content": [
      {
        "children": [
          {
            "key": "f04a504031050",
            "marks": [],
            "text": "”Drones will soon be the first choice for the inspection of overhead power lines. It’s just a question about how soon. The transition to start using drones has already begun and the right time for scaling is now. We see a market that is ready to take off with drones now being good enough, a new drone regulation framework harmonized throughout the EU, and increased client awareness. To be able to continue developing our product at a high pace and to accelerate our sales efforts, we need capital and knowledgeable investors – which we have found in VEQ” says Max Hjalmarsson, CEO of Airpelago.",
            "type": "span"
          }
        ],
        "key": "3015e2e21cb6",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c4eac3f6e948",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "64ae1a822f27",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "226b760167b60",
            "marks": [],
            "text": "Viktor Gällström is the lead partner from VEQ for the investment and comments: “We are very impressed by the Airpelago team. Besides having extensive experience from the drone ecosystem, they have managed to build a modular software that effectively solves a concrete customer need. We believe that Airpelago is well equipped to meet the increased maturity we now see in this market and we are proud to be a part of their journey”",
            "type": "span"
          }
        ],
        "key": "2269fede34b8",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "90409f1aa40c",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "fc5c4815c852",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c85c77afb7890",
            "marks": [],
            "text": "Read full press release ",
            "type": "span"
          },
          {
            "key": "c85c77afb7891",
            "marks": [
              "c3241b35a7ed"
            ],
            "text": "here",
            "type": "span"
          },
          {
            "key": "c85c77afb7892",
            "marks": [],
            "text": ".",
            "type": "span"
          }
        ],
        "key": "bb4088d01f60",
        "markDefs": [
          {
            "href": "https://www.airpelago.com/post/airpelago-closes-pre-seed-round",
            "key": "c3241b35a7ed",
            "type": "link"
          }
        ],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "We are now proud investors in food marketplace startup Lunch.Co",
    "date": "Sep 21, 2021",
    "category": "News",
    "link": "https://veq.vc/news/we-are-now-proud-investors-in-food-marketplace-startup-lunch-co",
    "slug": "we-are-now-proud-investors-in-food-marketplace-startup-lunch-co",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/59eb72ad76dec860d4cbfd936d4776973a20d86e-2560x1706.jpg",
    "description": "Lunch.Co has raised a €500k pre-seed round led by VEQ, together with Antler and foodtech VC Rockstart as co-investors. Lunch.Co plans to use the funding to provide new and exciting Food at Work experiences in leading companies in the Nordic region.",
    "content": [
      {
        "children": [
          {
            "key": "2685b9dcb6b10",
            "marks": [
              "42e99f991fcd"
            ],
            "text": "Lunch.Co",
            "type": "span"
          },
          {
            "key": "2685b9dcb6b11",
            "marks": [],
            "text": " is a marketplace, that allows colleagues to share their home-cooked meals with each other in the workplace while creating deeper connections and engagement in the office. Core to Lunch.Co’s business is building positive social impact and sustainability by allowing users to do good effortlessly by using the Lunch.Co platform. With this investment and their partnership with Sodexo – a global leader in contract catering, Lunch.Co is targeting the global workplace lunch market and will jointly enter offices to provide a unique meal provisioning offering as employees return to the office. Lunch.Co will also build on its partnership with Coop, Sweden’s leading grocery retailer, by improving Coop’s impact in food waste reduction, and is on track to achieve B Corp sustainability certification.",
            "type": "span"
          }
        ],
        "key": "a61725c2cb4e",
        "markDefs": [
          {
            "href": "https://www.lunch.co/",
            "key": "42e99f991fcd",
            "type": "link"
          }
        ],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "7d17d67d5186",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "5e6ab4066ce7",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "aecb662ecc770",
            "marks": [],
            "text": "Viktor Gällström, our Founding Partner comments:",
            "type": "span"
          }
        ],
        "key": "15fc65bb2ed0",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "4316603833730",
            "marks": [],
            "text": "“We are very excited to partner with the excellent team behind Lunch.Co. We were impressed by the founders’ vast experience from the food sector and we see enormous potential in this new and innovative vertical of the sharing economy. What is also very important to us are the values our investee companies stand for and Lunch.Co demonstrates their values by donating one meal to people in need for each meal bought on the platform.”",
            "type": "span"
          }
        ],
        "key": "767bb5dbe9ea",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "Today we welcome GLOBHE to the VEQ family!",
    "date": "Sep 13, 2021",
    "category": "News",
    "link": "https://veq.vc/news/today-we-welcome-globhe-to-the-veq-family",
    "slug": "today-we-welcome-globhe-to-the-veq-family",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/223cbdda064798d2ff9554864a49f0b85ace4d76-1536x715.png",
    "description": "We can finally announce that GLOBHE has raised a pre-seed round with VEQ as lead investor, together with co-investor angel network Sustainability Energy Angels. The company raises capital to scale goal of creating a better future with drones",
    "content": [
      {
        "children": [
          {
            "key": "7cae9c3abd050",
            "marks": [],
            "text": "We can finally announce that GLOBHE has raised a pre-seed round with VEQ as lead investor, together with co-investor angel network Sustainability Energy Angels. The company raises capital to scale goal of creating a better future with drones",
            "type": "span"
          }
        ],
        "key": "0c4540042d48",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "2ebc9536fffc",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "2aa26e3c2c7c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "38d0623a7d970",
            "marks": [],
            "text": "​​”Drones have incredible potential and we are seeing a market that now can grow at a different rate due to factors such as standardised drone laws in the EU and increased client awareness. So the time to scale is now and to do so you need capital and knowledgeable investors – which we have found in VEQ and Sustainable Energy Angels,” says Helena Samsioe, Founder and CEO GLOBHE.",
            "type": "span"
          }
        ],
        "key": "5e9eed22097e",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "f020f776a63f",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "35a1bc6c0eec",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "42a5906343850",
            "marks": [],
            "text": "GLOBHE has developed a digital platform called Crowddroning by GLOBHE which sends out local drone pilots to help B2B clients capture high-quality data on demand to detect and predict disasters around the world. Through Crowddroning, GLOBHE is making drone data available in a whole new way, and at a whole new scale, to help solve real life challenges around the world in 4 industries – health, water, environment and infrastructure. GLOBHE clients range from notable organisations such as the United Nations and the company recently signed a deal with a world leading telecom company.",
            "type": "span"
          }
        ],
        "key": "65c98bd35997",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "55cf20a84bf5",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "15127972926c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "07090e7b86ec0",
            "marks": [],
            "text": "Our VEQ Partner Maria Bergsten comments:\n“We’re very impressed by Helena and the GLOBHE team. They have extensive experience from both the drone and startup world as well as built a company that has been global from day one. GLOBHE’s large network with pilots all over the world and their scalable Crowddroning platform combined makes them a unique player in this space. We’re proud to be a part of their journey in using drones for a better future.”",
            "type": "span"
          }
        ],
        "key": "25556a88dcff",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "e00d5d27eac4",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "28934e334766",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "27274ea0c2160",
            "marks": [],
            "text": "The future is bright and the application areas for drones are endless but GLOBHE is staying close to its core of preventing and detecting disasters – but even so the use cases are many. Drones sent out via Crowddroning by GLOBHE are now helping prevent malaria outbreaks by identifying mosquito larval population target areas. This is just one of the many health threats out there and one of many disasters drones can help avoid. GLOBHE is also sending out drones to inspect infrastructure, guide relief workers post natural disasters and monitor water pollution. Today over 3800 drone pilots in 88 countries are connected to Crowddroning by GLOBHE.",
            "type": "span"
          }
        ],
        "key": "eca09f505564",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "013888b00c4d",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "9842e326668e",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "9dae623338630",
            "marks": [],
            "text": "We are so happy to be joining forces with the GLOBHE team and we can’t wait to see what the future holds!",
            "type": "span"
          }
        ],
        "key": "d332e46e6953",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "38a5d864b281",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "c9a550bba205",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "4e2a615477510",
            "marks": [],
            "text": "Read full press release ",
            "type": "span"
          },
          {
            "key": "4e2a615477511",
            "marks": [
              "145334cf14d1"
            ],
            "text": "here.",
            "type": "span"
          }
        ],
        "key": "76cb1512a6e2",
        "markDefs": [
          {
            "href": "https://globhe.com/13-09-2021-globhe-raising-new-capital-for-scaleup",
            "key": "145334cf14d1",
            "type": "link"
          }
        ],
        "style": "normal",
        "type": "block"
      }
    ]
  },
  {
    "title": "We’re launching VEQ today!",
    "date": "Jun 21, 2021",
    "category": "News",
    "link": "https://veq.vc/news/we-re-launching-veq-today",
    "slug": "we-re-launching-veq-today",
    "image": "https://cdn.sanity.io/images/rojcdk15/production/3ba143306455759567803edad94b4a835fb6fc88-1536x714.png",
    "description": "Today, VEQ, a new Stockholm based venture capital investor focusing on investments in early-stage digital technology companies, is launching.  VEQ is providing early-stage start-ups with both capital as well as a range of services and expertise available through VEQ’s sister company VNTRS.",
    "content": [
      {
        "children": [
          {
            "key": "317395ea9d710",
            "marks": [],
            "text": "VEQ was founded by the digital consulting company and sweat equity investor VNTRS, whose investment team now have partnered up with well renowned venture & growth investor Alfvén & Didrikson, as well as a handful of additional investors with backgrounds from the technology sector. Together, they have formed VEQ with the vision to be a long-term backer of entrepreneurs in early stages.",
            "type": "span"
          }
        ],
        "key": "2a80ad515126",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "c822bf6e2a540",
            "marks": [],
            "text": "“",
            "type": "span"
          },
          {
            "key": "594382bdb4f8",
            "marks": [
              "em"
            ],
            "text": "We are really excited about getting this opportunity, being able to back more great entrepreneurs from within and outside of our network. One aspect that is important to us is to invest in diversified teams that leave some kind of positive impact in our world. And to have partners such as Alfvén & Didrikson as our backers on this adventure feels very promising and inspiring",
            "type": "span"
          },
          {
            "key": "14c6832eaa24",
            "marks": [],
            "text": "” – Viktor Gällström",
            "type": "span"
          }
        ],
        "key": "1ee10b68de7d",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "30281cd9a60c0",
            "marks": [],
            "text": "VEQ will invest in pre-seed and seed rounds with a mandate all over Europe, with focus on the Nordics and the Baltics, where VNTRS also has presence. VEQ does not have a traditional fund structure and will be able to contribute and remain a long term active owner for as long as it makes sense for the company and VEQ. The initial plan is to invest 300 kEUR to 1 mEUR each in about a dozen start-ups over the next couple of years.\nAnother important differentiating factor is that VEQ, through its close cooperation with the sister company VNTRS, will have access to extensive knowledge and hands-on experts such as developers, designers, and growth hackers, to help VEQ’s investee companies accelerate their growth. This makes VEQ one of the few hands-on operational venture capital investors in the Nordics.",
            "type": "span"
          }
        ],
        "key": "029fb22e470c",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "18c58307bb7c0",
            "marks": [],
            "text": "“",
            "type": "span"
          },
          {
            "key": "b47f45bea0be",
            "marks": [
              "em"
            ],
            "text": "We are very impressed by VNTRS and the selection of companies they have invested in with sweat equity. They have extensive technical expertise and have built a company with an attractive culture, sound values and a true desire to help entrepreneurs succeed. At Alfvén & Didrikson, we have been looking for a way to support more companies in early stages and we are now very excited to be able to do that through our partnership with VEQ",
            "type": "span"
          },
          {
            "key": "b0ed51be99a7",
            "marks": [],
            "text": "” – Måns Alfvén",
            "type": "span"
          }
        ],
        "key": "521e25bf9d2d",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "9cd429b55bbc0",
            "marks": [],
            "text": "The day-to-day team running VEQ consists of Viktor Gällström and Maria Bergsten.",
            "type": "span"
          }
        ],
        "key": "3e9449793d5d",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "a3318e3c150e",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "7292b1e0bce9",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "28758f43a23d0",
            "marks": [],
            "text": "To get in touch, reach out to Viktor Gällström or Maria Bergsten at ",
            "type": "span"
          },
          {
            "key": "28758f43a23d1",
            "marks": [
              "0762698bdbdd"
            ],
            "text": "viktor@veq.vc",
            "type": "span"
          },
          {
            "key": "28758f43a23d2",
            "marks": [],
            "text": " and ",
            "type": "span"
          },
          {
            "key": "28758f43a23d3",
            "marks": [
              "4cdf8f245b40"
            ],
            "text": "maria@veq.vc",
            "type": "span"
          },
          {
            "key": "28758f43a23d4",
            "marks": [],
            "text": ".",
            "type": "span"
          }
        ],
        "key": "7f584796bd67",
        "markDefs": [
          {
            "href": "mailto:viktor@veq.vc",
            "key": "0762698bdbdd",
            "type": "link"
          },
          {
            "href": "mailto:maria@veq.vc",
            "key": "4cdf8f245b40",
            "type": "link"
          }
        ],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "1c0ba704e14a",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "95080b3643f9",
        "markDefs": [],
        "style": "normal",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "a6969340498b0",
            "marks": [],
            "text": "VNTRS, founded in 2016, is a digital consulting company and sweat equity investor. VNTRS partners up with entrepreneurs and companies to create successful businesses together by providing the right type of competence within tech, growth, design, and business development. For more information see ",
            "type": "span"
          },
          {
            "key": "a6969340498b1",
            "marks": [
              "915a148f15a0"
            ],
            "text": "www.vntrs.com",
            "type": "span"
          }
        ],
        "key": "425b2a092f90",
        "markDefs": [
          {
            "href": "https://vntrs.com/",
            "key": "915a148f15a0",
            "type": "link"
          }
        ],
        "style": "h6",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "38b98df620720",
            "marks": [],
            "text": "Alfvén & Didrikson is an active and long term backer of passionate entrepreneurs and teams with international growth ambitions. Since 2010, the Alfvén & Didrikson team has made investments in fast growing European companies such as Trustly, Quinyx, Acast, Mentimeter, Sympa and Klevu. ",
            "type": "span"
          }
        ],
        "key": "06090319bdbc",
        "markDefs": [
          {
            "href": "http://www.alfvendidrikson.com/",
            "key": "280818408ddc",
            "type": "link"
          }
        ],
        "style": "h6",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "8c31446511fd",
            "marks": [],
            "text": "",
            "type": "span"
          }
        ],
        "key": "c70d4d59fd90",
        "markDefs": [],
        "style": "h6",
        "type": "block"
      },
      {
        "children": [
          {
            "key": "4fe6fc0eab97",
            "marks": [],
            "text": "For more information see ",
            "type": "span"
          },
          {
            "key": "38b98df620721",
            "marks": [
              "280818408ddc"
            ],
            "text": "www.alfvendidrikson.com",
            "type": "span"
          }
        ],
        "key": "32901707c183",
        "markDefs": [
          {
            "href": "https://www.alfvendidrikson.com/",
            "key": "280818408ddc",
            "type": "link"
          }
        ],
        "style": "h6",
        "type": "block"
      }
    ]
  }
];
